// extracted by mini-css-extract-plugin
module.exports = {"ImageGalleryUI":"ImageGalleryUI_ImageGalleryUI__oQ0zk","cssAnimation":"ImageGalleryUI_cssAnimation__qNhVT"};